import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { MdlDialogService, IMdlCustomDialogConfiguration, MdlDialogReference } from '@angular-mdl/core';
import { CreateStudyGroupComponent, STUDY_GROUP_CREATE_TOKEN } from '../../create-study-group/create-study-group.component';
import { StudyGroupInfo } from '../../group-info/study-group-info';
import { MessageDialogRequest, MessageDialogComponent, MESSAGE_SERVICE_TOKEN } from './message-dialog/message-dialog.component';
import { ViewStudyGroupComponent, STUDY_GROUP_VIEW_TOKEN } from '../../view-study-group/view-study-group.component';
import { DeleteStudyGroupComponent, STUDY_GROUP_DELETE_TOKEN } from '../../delete-study-group/delete-study-group.component';
import { EditStudyGroupComponent, STUDY_GROUP_EDIT_TOKEN, STUDY_GROUP_EDIT_INFO_TOKEN } from '../../edit-study-group/edit-study-group.component';
import { ReportData } from '../../reports/interfaces/report-data';
import { DELETE_REPORT_TOKEN, DeleteReportComponent } from '../../reports/delete-report/delete-report.component';

@Injectable()
export class SampleTrackingDialogService {

    constructor(
        private readonly dialogService: MdlDialogService) {

    }

    public showCreateDialog(studyGroupInfo: StudyGroupInfo[]): Observable<MdlDialogReference> {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: CreateStudyGroupComponent,
            providers: [{
                provide: STUDY_GROUP_CREATE_TOKEN, useValue: studyGroupInfo
            }],
            isModal: true,
            classes: 'sample-tracking-dialog',
            clickOutsideToClose: true
        };

        return this.dialogService.showCustomDialog(configDialog);
    }

    public showPostActionDialogue(message: string, success: boolean, left?: string) {

        const messageRequest = new MessageDialogRequest();
        messageRequest.isSuccess = success;
        messageRequest.title = success ? 'Success!' : 'Error!';
        messageRequest.message = message;
        messageRequest.icon = success ? 'check_circle' : 'error';

        var color = messageRequest.isSuccess ? '#069D06' : '#FF2E2E';

        const configDialog: IMdlCustomDialogConfiguration = {
            component: MessageDialogComponent,
            providers: [{
                provide: MESSAGE_SERVICE_TOKEN, useValue: messageRequest
            }],
            isModal: true,
            styles: { 'background-color': color, 'width': '400px', 'bottom': '100%', 'left': left ? left : '900px' },
            clickOutsideToClose: true
        };

        this.dialogService.showCustomDialog(configDialog);
    }

    public showViewDialog(studyGroupInfo: StudyGroupInfo): Observable<MdlDialogReference> {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: ViewStudyGroupComponent,
            providers: [{
                provide: STUDY_GROUP_VIEW_TOKEN, useValue: studyGroupInfo
            }],
            isModal: true,
            classes: 'sample-tracking-dialog',
            clickOutsideToClose: true
        };

        return this.dialogService.showCustomDialog(configDialog);
    }

    public showDeleteDialog(studyGroupInfo: StudyGroupInfo): Observable<MdlDialogReference> {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: DeleteStudyGroupComponent,
            providers: [{
                provide: STUDY_GROUP_DELETE_TOKEN, useValue: studyGroupInfo
            }],
            isModal: true,
            classes: 'sample-tracking-dialog',
            clickOutsideToClose: true
        };

        return this.dialogService.showCustomDialog(configDialog);
    }

    public showEditDialog(allStudyGroups: StudyGroupInfo[], studyGroupInfo: StudyGroupInfo): Observable<MdlDialogReference> {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: EditStudyGroupComponent,
            providers: [{
                provide: STUDY_GROUP_EDIT_TOKEN, useValue: allStudyGroups,

            },
            {
                provide: STUDY_GROUP_EDIT_INFO_TOKEN, useValue: studyGroupInfo
            }],
            isModal: true,
            classes: 'sample-tracking-dialog',
            clickOutsideToClose: true
        };

        return this.dialogService.showCustomDialog(configDialog);
    }

    public showDeleteReportDialog(reportData: ReportData): Observable<MdlDialogReference> {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: DeleteReportComponent,
            providers: [{
                provide: DELETE_REPORT_TOKEN, useValue: reportData
            }],
            isModal: true,
            classes: 'st-report-delete-dialog',
            clickOutsideToClose: true
        };

        return this.dialogService.showCustomDialog(configDialog);
    }
}